// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__3DxKb","loading":"Loading_loading__3SgGS","bounce":"Loading_bounce__c0-YM","dot2":"Loading_dot2__1tsWG","dot3":"Loading_dot3__384mg"};